import { useCallback } from "react";

import { useIntl, defineMessages } from "react-intl";

import { Icon } from "flavours/glitch/components/icon";

const messages = defineMessages({
  load_more: { id: "status.load_more", defaultMessage: "Load more" },
});

interface Props {
  disabled: boolean,
  maxId: string,
  belowId?: string | null,
  onClick: (maxId: string, belowId?: string | null) => void,
}

export const LoadGap: React.FC<Props> = ({ disabled, maxId, belowId, onClick }) => {
  const intl = useIntl();

  const handleClick = useCallback(() => {
    onClick(maxId, belowId);
  }, [maxId, belowId, onClick]);

  return (
    <button
      className='load-more load-gap'
      disabled={disabled}
      onClick={handleClick}
      aria-label={intl.formatMessage(messages.load_more)}
    >
      <Icon id='dots-three-filled' />
    </button>
  );
};
